import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
import { Field } from 'redux-form/immutable';
import { required } from '../validators';
import { SimpleInput } from '../field-components';

function FullName({ formName }) {
  return (
    <React.Fragment>
      <div className="item clearfix">
        <label className="form-label text-left col-md-3">
          <FormattedMessage {...messages.surname} />
        </label>
        <Field name={`${formName}[last_name]`} validate={[required]} component={SimpleInput} type="text" />
      </div>
      <div className="item clearfix">
        <label className="form-label text-left col-md-3" style={{ marginTop: 5 }}>
          <FormattedMessage {...messages.name} />
        </label>
        <Field name={`${formName}[first_name]`} validate={[required]} component={SimpleInput} type="text" />
      </div>
      <div className="item clearfix">
        <label className="form-label text-left col-md-3" style={{ lineHeight: 'inherit', marginTop: 10 }}>
          <FormattedMessage {...messages.secondName} />
        </label>
        <Field name={`${formName}[middle_name]`} component={SimpleInput} type="text" />
      </div>
    </React.Fragment>
  );
}

export default FullName;



// WEBPACK FOOTER //
// ./src/application-form/sections/fullname.js